export const lang = {
	TITLE: 'Upgrade to Family',
	DESCRIPTION: (price: string) => `Get 5 accounts instead of 1, for just ${price} extra`
};
